import React from "react";
import { Link } from "react-router-dom";
import "./AboutSection.css";
import aboutImg from "../assets/images/about.jpg";

const AboutSection = () => {
  return (
    <section className="about-section" id="nosotros">
      <div className="about-container">
        <div className="about-text">
          <h2>Palabras del Director General:</h2>
          <p>
            “Querido estudiante balliviano: Muchos son los llamados, pero pocos los 
            escogidos; y, uno de ellos has sido tú. Haced del estudio un hábito. 
            Escucha a tus profesores, pero ten el criterio para discernir entre lo 
            bueno y lo malo. Ellos también pueden equivocarse. Que sea el respeto y 
            la responsabilidad la piedra angular que guía tu vida. Frente a obstáculos, 
            busca la forma de vencerlos utilizando la inteligencia y el criterio. 
            Nunca hagas sólo lo que te piden, da todo de ti, siempre en busca de la 
            excelencia. Capacítate permanentemente y serás orgullo de tu profesión"
          </p>
         <div className="director-info">
            <Link to="/director" className="director-name">
              Dr. Ledgar Sovero Sovero
            </Link>
            <p className="director-title">Director General</p>
          </div>

        </div>
        <div className="about-image">
          <img src={aboutImg} alt="Instituto Gilda Ballivián" />
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
